import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'
import { formatRegistrationDate } from '../../../../../components/common/time/timeHelper'
import './checks.scss'

const CheckLawSuits = ({ lawSuitsCheck }) => {
  const { t } = useTranslation(['common', 'messages'])
  const details = lawSuitsCheck?.checkDetails
  const hasChecks = details && details.TotalLawsuits
  const checkLength = details?.TotalLawsuits || 0

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:lawsuits')} {t('common:shareholders')}</Typography>
        <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} label="Processo" />
      </Paper>

      <CheckDetailTitle
        email={lawSuitsCheck?.email}
        status={lawSuitsCheck?.status}
        createdAt={lawSuitsCheck?.createdAt}
        updatedAt={lawSuitsCheck?.updatedAt}
      />

      {hasChecks ? (
        <TimelineDotLine>
          <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
            <div className="c-detail-grid">
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:totalLawsuits')}</Typography>
                <Typography variant="subtitle3">{details.TotalLawsuits ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:totalLawsuits')} {t('common:asAuthor')}</Typography>
                <Typography variant="subtitle3">{details.TotalLawsuitsAsAuthor ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:totalLawsuits')} {t('common:asDefendant')}</Typography>
                <Typography variant="subtitle3">{details.TotalLawsuitsAsDefendant ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:totalLawsuits')} {t('common:asOther')}</Typography>
                <Typography variant="subtitle3">{details.TotalLawsuitsAsOther ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:firstLawsuitDate')}</Typography>
                <Typography variant="subtitle3">
                  {details.FirstLawsuitDate && formatRegistrationDate(details.FirstLawsuitDate).endsWith('1901')
                    ? '---'
                    : formatRegistrationDate(details.FirstLawsuitDate)}
                </Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:lastLawsuitDate')}</Typography>
                <Typography variant="subtitle3">{formatRegistrationDate(details.LastLawsuitDate).endsWith('9999')
                    ? '---'
                    : formatRegistrationDate(details.LastLawsuitDate)}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:last30')} {t('common:lawsuits')}</Typography>
                <Typography variant="subtitle3">{details.Last30DaysLawsuits ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:last90')} {t('common:lawsuits')}</Typography>
                <Typography variant="subtitle3">{details.Last90DaysLawsuits ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:last180')} {t('common:lawsuits')}</Typography>
                <Typography variant="subtitle3">{details.Last180DaysLawsuits ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:last365')} {t('common:lawsuits')}</Typography>
                <Typography variant="subtitle3">{details.Last365DaysLawsuits ?? '---'}</Typography>
              </div>
              {details.informação && (
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:information')}</Typography>
                  <Typography variant="subtitle3">{details.informação}</Typography>
                </div>
              )}
            </div>
          </Paper>
        </TimelineDotLine>
      ) : (
        <Paper elevation={0} sx={{ flex: 1 }}>
          <Typography variant="body1" sx={{ marginTop: 2 }}>
            {t('messages:noDataCheckAvailable')}
          </Typography>
        </Paper>
      )}
    </>
  )
}

export default CheckLawSuits

/* import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import { toLocaleUTCDateString } from '../../../components/common/time/timeHelper'

const variantByLevel = {
  0: 'h3',
  1: 'h4',
}

const CheckLawSuits = ({ title = '', lawSuitsCheck, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])
  return (
    <Box className="detail-group">
      <Typography variant={variantByLevel[level] || variantByLevel[0]}>
        {title || `${t('common:lawsuits')} ${t('common:shareholders')}`}
      </Typography>
      <CheckDetailTitle
        email={lawSuitsCheck.email}
        status={lawSuitsCheck.status}
        createdAt={lawSuitsCheck.createdAt}
        updatedAt={lawSuitsCheck.updatedAt}
      />
      <Box>
        <h4>{t('common:sanctions')}</h4>
        <Box className="group-table">
          <table className="bs bst group-table">
            <thead>
              <tr className="group-table">
                <th className="bs">{t('common:firstLawsuitDate')}</th>
                <th className="bs">{t('common:lastLawsuitDate')}</th>
                <th className="bs">
                  {t('common:last90')} {t('common:lawsuits')}
                </th>
                <th className="bs">{t('common:averagePerOwner')}</th>
                <th className="bs">{t('common:activeOwners')}</th>
                <th className="bs">{t('common:total')}</th>
              </tr>
            </thead>
            <tbody>
              <tr className="group-table">
                <td className="bs table-cell col-3">
                  {toLocaleUTCDateString(lawSuitsCheck?.checkDetails?.FirstLawsuitDate) ?? '---'}
                </td>
                <td className="bs table-cell col-3">
                  {toLocaleUTCDateString(lawSuitsCheck?.checkDetails?.LastLawsuitDate) ?? '---'}
                </td>
                <td className="bs table-cell col-4">{lawSuitsCheck?.checkDetails?.Last90DaysLawsuits ?? '---'}</td>
                <td className="bs table-cell col-4">{lawSuitsCheck?.checkDetails?.AverageLawsuitsPerOwner ?? '---'}</td>
                <td className="bs table-cell col-4">{lawSuitsCheck?.checkDetails?.ActiveOwners?.length ?? '---'}</td>
                <td className="bs table-cell col-4">{lawSuitsCheck?.checkDetails?.TotalLawsuits ?? '---'}</td>
              </tr>
            </tbody>
          </table>
        </Box>
      </Box>
      {lawSuitsCheck.checkDetails?.informação && (
        <Box>
          <span>{t('common:data')}</span>
          <p>{lawSuitsCheck.checkDetails.informação}</p>
        </Box>
      )}
    </Box>
  )
}

export default CheckLawSuits
 */
